import { requestWithToken } from '../utilities/request';
const path = '/api/private/user_agency_registration_permissions';

/**
 * 代行登録許可ユーザー登録
 * @param param {object}
 */
const create = param => {
  return requestWithToken({
    method: 'POST',
    url: `${path}`,
    params: param,
    validateStatus(status) {
      // Reject only if the status code 400
      return status === 400 || status === 200;
    },
  });
};

/**
 * リスト取得
 * @param param {object}
 */
const list = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const registableAgencyUsersList = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/registable_agency_users_list`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const agencyUsersList = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/agency_users_list`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const addAgencyUsers = param => {
  return requestWithToken({
    method: 'POST',
    url: `${path}`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const revokeAgencyUsers = param => {
  return requestWithToken({
    method: 'DELETE',
    url: `${path}/destroy_list`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

export const UserAgencyService = {
  create,
  list,
  registableAgencyUsersList,
  agencyUsersList,
  addAgencyUsers,
  revokeAgencyUsers,
};
export default UserAgencyService;



// WEBPACK FOOTER //
// ./src/services/UserAgency.js